import React, { FunctionComponent } from 'react';

import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import AppState from '@webapp/store/state';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import Box from '@components/layout/box';
import Grid from '@components/basics/grid';
import Typography from '@components/basics/typography';

import ComparativeItem, { ComparativeItemType } from './comparative-item';
import { GetArtistAnalytics } from '@webapp/store/artist-analytics/action-creators';
import { AnalyticsQueryTypes } from '@services/analytics/types/analytics-query-enum';

interface AgeRangeBoxProps {
  className?: string;
  data: ComparativeItemType[];
  isMobile: boolean;
  artistId?: string;
  getAgeGroupAnalytics: () => GetArtistAnalytics;
}

const mapStateToProps = (state: AppState) => ({
  data:
    state.artistAnalytics.data?.ageRange
      ?.filter((i) => i.value > 0)
      ?.map((item) => {
        return {
          label: item.category,
          value: item.change,
          streams: item.value,
          percentage: item.percentChange,
        };
      })
      .reverse() || [],
  artistId: state.artist.active?.id,
  isMobile: state.ui.mobile,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getAgeGroupAnalytics: () =>
    dispatch(new GetArtistAnalytics(AnalyticsQueryTypes.AGE, undefined, true)),
});

const AgeRangeBox: FunctionComponent<AgeRangeBoxProps> = ({
  className,
  data,
  isMobile,
  artistId,
  getAgeGroupAnalytics,
}) => {
  React.useEffect(() => {
    if (artistId) {
      getAgeGroupAnalytics();
    }
  }, [artistId, getAgeGroupAnalytics]);

  return (
    <Box className={className || ''} noBorderTop noBorderRight={!isMobile}>
      <Typography className="title" type="title" customFont="semi-bold">
        <Translate id="ANALYTICS.DEMOGRAPHIC.AGE.TITLE" />
      </Typography>
      <Grid gap={20}>
        {data
          .sort((a, b) => b.streams - a.streams)
          .map((range, i) => (
            <ComparativeItem key={i} item={range} />
          ))}
      </Grid>
    </Box>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(AgeRangeBox)`
  .title {
    margin-bottom: 20px;
  }
`);
